import Vue from 'vue'
import Vconsole from 'vconsole'

const vConsole = process.env.NODE_ENV === 'development' ? new Vconsole() : {}

Vue.use(vConsole)
